import { IPAGE } from '@/types/base.d';
import { IVerify } from '@/types/verify.d';
import fetch from './index';

// 获取作品列表
const getWorks = (params: IPAGE, status: number, title: string, orgPid: string) => fetch.axios_admin.get(`/project/all?status=${status}&title=${title}&orgPid=${orgPid}`, { params });

// 提交审核
const submitVerify = (data: IVerify) => fetch.axios_admin.post('/project/audit', data);

// 获取机构名称
const getOrg = () => fetch.axios_admin.get('/org/root/start');

// 获取作品审核纪律
const getVerifyList = (projectId: string) => fetch.axios_admin.get(`/project/auditRecord?projectId=${projectId}`);

export default {
  getWorks,
  submitVerify,
  getOrg,
  getVerifyList,
};
